import Moment from "react-moment";
import "moment-timezone";
import "moment/locale/it";
import currencyFormat from "../functions/functions";
import Label from "../Label";
import "../../css/LocalHistory.css";

function OrderSheet({ order, setOrder, loadBillUrl, showReceiptButton = false }) {
	if (!order) return null;

	return (
		<div className="order-sheet">
			<div className="info-order">
				<div>
					<h3><Label number={175} /> {order.number ? `N.${order.number} - ` : ""}ID:{order.id}</h3>
					<p className="mb-0">
						<Label number={176} />:{" "}
						<Moment format={"DD/MM/YYYY LT"} locale="it">
							{order.delivery_date}
						</Moment>
					</p>
					<p className="mb-0"><Label number={177} />: {order.delivery_type}</p>
					<p className="mb-0"><Label number={178} />: {order.origin}</p>
				</div>
				<div>
					<img
						src={
							"https://api.yellgo.cloud/class/barcode.php?f=png&s=qr&p=0&w=500&h=500&d=" +
							order.id
						}
					/>
				</div>
			</div>
			<div className="product-order">
				<p className="title mb-0"><Label number={179} />:</p>
				<div className="list-products">
					{order.products.map((product, i) => (
						<div key={i} className="single-product">

							<div>{product.qty}x {product.name}</div>
							<div>{currencyFormat(product.price, false, order.currency)}</div>

						</div>
					))}
				</div>
				<div className="bold total-order">
					<div><Label number={25} />:</div>
					<div>{currencyFormat(order.total, false, order.currency)}</div>
				</div>
			</div>
			<div className="order-sheet-actions">
				{showReceiptButton && (
					<button className="basic-button" onClick={() => loadBillUrl(order)}>
						<Label number={171} />
					</button>
				)}
				<button className="basic-button" onClick={() => setOrder(false)}>
					<Label number={182} />
				</button>
			</div>
		</div>
	);
}

export default OrderSheet;
